var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.costCenterErrors },
        on: {
          "update:errors": function($event) {
            _vm.costCenterErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: { headers: _vm.headers, items: _vm.costCenterList },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.code))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            text: "",
                            small: "",
                            bottom: "",
                            dark: "",
                            color: "yellow darken-3",
                            tooltip: "Edit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }